import AsideMenuData from 'src/app/components/AsideMenuData'

export const AsideMenuMain = AsideMenuData
